const initAccordionLists = () => {
	const blocks = document.querySelectorAll('[data-accordion-list-block]');

	blocks.forEach((block) => {
		if (block.dataset.accordionListInitialized === 'true') {
			return;
		}

		block.dataset.accordionListInitialized = 'true';

		const allowMultipleOpen = block.dataset.allowMultipleOpen === 'true';
		const items = Array.from(block.querySelectorAll('[data-accordion-list-item]'));

		if (!items.length) {
			return;
		}

		const closeItem = (item) => {
			const trigger = item.querySelector('[data-accordion-list-trigger]');
			const panel = item.querySelector('[data-accordion-list-panel]');

			item.classList.remove('is-open');

			if (trigger) {
				trigger.setAttribute('aria-expanded', 'false');
			}

			if (panel) {
				panel.hidden = true;
			}
		};

		const openItem = (item) => {
			const trigger = item.querySelector('[data-accordion-list-trigger]');
			const panel = item.querySelector('[data-accordion-list-panel]');

			item.classList.add('is-open');

			if (trigger) {
				trigger.setAttribute('aria-expanded', 'true');
			}

			if (panel) {
				panel.hidden = false;
			}
		};

		items.forEach((item) => {
			const trigger = item.querySelector('[data-accordion-list-trigger]');

			if (!trigger) {
				return;
			}

			trigger.addEventListener('click', () => {
				const isOpen = item.classList.contains('is-open');

				if (!allowMultipleOpen) {
					items.forEach((otherItem) => {
						if (otherItem !== item) {
							closeItem(otherItem);
						}
					});
				}

				if (isOpen) {
					closeItem(item);
				} else {
					openItem(item);
				}
			});
		});
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAccordionLists);
} else {
	initAccordionLists();
}
